import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { searchProdbyCabys, searchProdByDescripcion, clearErrors } from '../../actions';

import { Icon } from 'semantic-ui-react'

let timer = null;

const SearchCabys = (props) => {

    const { isLoading, searchCabysState, onSelectProducto } = props;
    const [buscarPor, setBuscarPor] = useState('');

    useEffect(() => {
        searchCabysState?.search ? setBuscarPor(decodeURI(searchCabysState?.search)) : setBuscarPor('');
    }, [searchCabysState])

    const onChangeSearch = (value) => {

        clearTimeout(timer);
        if (value?.length > 3 && !isLoading) {

            value.match(/^[0-9]+$/) ?
                timer = setTimeout(() => props.searchProdbyCabys(value), 500)
                :
                timer = setTimeout(() => props.searchProdByDescripcion(encodeURIComponent(value)), 500)

        }
        setBuscarPor(value);

    }

    return (
        <div className="search-container">
            <div className="ui grid">
                <div className="sixteen wide column">
                    <div className="ui search">
                        <div className="ui icon input">
                            <input
                                type="text"
                                className="prompt"
                                value={buscarPor}
                                onChange={(e) => onChangeSearch(e.target.value)}
                            />
                            {
                                isLoading && <Icon loading name='spinner' />
                            }
                        </div>
                    </div>
                </div>
                <div className="sixteen wide column">

                    <div className="inventario-list">

                        {
                            (searchCabysState?.searchCabys != null && buscarPor.length > 3) &&
                            <ul className=" scroll-list list-group list-group-flush">
                                {

                                    searchCabysState?.searchCabys.map((item) => (
                                        <li style={{ cursor: "pointer" }} key={`${item.codigo}`} type="button" onClick={(e) => {
                                            e.stopPropagation(); onSelectProducto(
                                                {
                                                    ...item
                                                }
                                            )
                                        }}>
                                            {item.codigo} - {item.descripcion}
                                        </li>
                                    ))

                                }
                                <br />
                            </ul>
                        }
                    </div>
                </div>
            </div>
        </div>
    )
};


const mapStateToProps = (state) => {
    return {
        errorState: state.errorState,
        searchCabysState: state.searchCabys,
        isLoading: state.isLoadingState,
    };
}

export default connect(mapStateToProps, {
    clearErrors,
    searchProdbyCabys,
    searchProdByDescripcion
})(SearchCabys);
